import React from 'react';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import colors from '../../styles/themes/variables.module.scss';
import styles from './styles.module.scss';

const beneficios = [
  { Icono: LocalShippingOutlinedIcon, texto: 'Envíos a todo el país', color: colors.green },
  { Icono: AutoAwesomeOutlinedIcon, texto: 'Diseños artesanales y originales', color: colors.pink2 },
  { Icono: ChatBubbleOutlineOutlinedIcon, texto: 'Atención personalizada por WhatsApp', color: colors.blue },
];

const FranjaBeneficios = () => {

  return (
    <div className={styles.contenedor}>
      <div className={styles.fila}>
        {beneficios.map((item) => (
          <div className={styles.beneficioItem} key={item.texto}>
            <div className={styles.iconoContenedor} style={{ backgroundColor: item.color }}>
              <item.Icono />
            </div>
            <span>{item.texto}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FranjaBeneficios;
